import customAxios from "../serverCall";

const getThemePlanSettings = async () => {
  const response = await customAxios.get(`/admin/dark-theme/settings`);
  return response;
};

const createThemePlanSettings = async (body) => {
  // Map coins_per_month to coins as expected by the API
  const createData = {
    coins: body.coins_per_month || body.coins || 0,
    discount_percentage: body.discount_percentage || 0,
    description: body.description || "Dark theme one-time purchase pricing",
    is_active: body.is_active !== undefined ? body.is_active : true,
  };
  const response = await customAxios.post(`/admin/dark-theme/settings/create`, createData);
  return response;
};

const updateThemePlanSettings = async (body) => {
  // Map coins_per_month to coins as expected by the API
  const updateData = {
    coins: body.coins_per_month || body.coins || 0,
    discount_percentage: body.discount_percentage || 0,
    description: body.description || "Updated dark theme one-time purchase pricing",
  };
  const response = await customAxios.post(`/admin/dark-theme/settings/update`, updateData);
  return response;
};

const DarkThemeService = {
  getThemePlanSettings,
  createThemePlanSettings,
  updateThemePlanSettings,

};

export default DarkThemeService;

